// todo: Break It Down
import React, { useEffect, useRef, useState } from "react";
import {
  Map,
  TileLayer,
  FeatureGroup,
  withLeaflet,
  Polygon,
} from "react-leaflet";
//Leaflet
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";

import { SpeedDial, SpeedDialAction } from "@mui/material";
import {
  LocalShipping as VehicleIcon,
  PeopleAlt as PeopleIcon,
  FilterAlt as FilterIcon,
} from "@mui/icons-material";

import PrintControlDefault from "react-leaflet-easyprint";
import { EditControl } from "react-leaflet-draw";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import SkeletonBox from "components/Custom/SkeletonBox";
import TripDeliveries from "components/MapPage/TripDeliveries";
import Radar from "components/MapPage/Radar";
import AreaVehiclesInfo from "components/MapPage/AreaVehiclesInfo";
import FutureView from "components/MapPage/FutureView";
import MapPlotting from "components/MapPage/MapPlotting";
import MapMarkers from "./MapMarkers";
import MapFilters from "./MapFilters";
import PolyFilters from "./PolyFilters";

import {
  CONFIG,
  DEFAULTS,
  LOCAL_STORAGE,
  MAP_MARKER_TYPES,
} from "common/config";
import { DateFunctions } from "common/datefunctions";
import { INFO, LABELS } from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiIndents } from "apihandlers/indent";
import { ApiMasters } from "apihandlers/masters/masters";
import { ApiGeography } from "apihandlers/geography";

import "./styles.css";

const API_HANDLER_MASTER = new ApiMasters();
const API_HANDLER_GEOGRAPHY = new ApiGeography();
const API_HANDLER_INDENT = new ApiIndents();

// wrap `PrintControl` component with `withLeaflet` HOC
const PrintControl = withLeaflet(PrintControlDefault);

const actions = [
  { id: "vehicles", icon: <VehicleIcon />, name: LABELS.VEHICLES_LIST },
  { id: "users", icon: <PeopleIcon />, name: LABELS.USERS },
];

const MapPage = (props: any) => {
  const tripsRef: any = useRef();
  const vehiclesRef: any = useRef();
  const driverRef: any = useRef();
  const printControlRef: any = useRef(null);
  const mapRef: any = useRef(null);
  const deliveriesRef: any = useRef(null);
  const mapDrawControlGroupRef: any = useRef(null);
  const mapDrawControlRef: any = useRef(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [showLabels, setShowLabels] = useState<boolean>(true);
  const [showAreas, setShowAreas] = useState<boolean>(true);
  const [showTrips, setShowTrips] = useState<boolean>(false);
  const [showVehicles, setShowVehicles] = useState<boolean>(false);
  const [showMarkers, setShowMarkers] = useState<boolean>(true);
  const [clustering, setClustering] = useState<boolean>(true);
  const [vehicles, setVehicles] = useState<any>([]);
  const [details, setDetails] = useState<boolean>(false);
  const [futureViewVehicles, setFutureViewVehicles] = useState<any>(null);
  const [futureVehicle, setFutureVehicle] = useState<any>(false);
  const [areas, setAreas] = useState<any[]>([]);
  const [tripDelivery, setTripDelivery] = useState<any>(null);
  const [trips, setTrips] = useState<any>([]);
  const [radarMainVehicle, setRadarMainVehicle] = useState<any>(null);
  const [radarData, setRadarData] = useState<any>(null);
  const [nearVehicles, setNearVehicles] = useState<any>(null);
  const [drivers, setDrivers] = useState<any>([]);
  const [vehiclesList, setVehiclesList] = useState<any>([]);
  const [showRadar, setShowRadar] = useState<boolean>(false);
  const [filteredList, setFilteredList] = useState<any>(null);
  const [locMarker, setLocMarker] = useState<any>({});
  const [filter, setFilter] = useState<any>(LABELS.VEHICAL_LIST);
  const [selectedPolygon, setSelectedPolygon] = useState<any>([]);
  const [polygonVehicles, setPolygonVehicles] = useState<any>([{}]);
  const [polygonInfo, setPolygonInfo] = useState<any>({});
  const [showDelay, setShowDelay] = useState<boolean>(false);
  const [delayedVehicles, setDelayedVehicles] = useState<any>([]);
  const [radarLoading, setRadarLoading] = useState<boolean>(false);
  const [showRoutePoints, setShowRoutePoints] = useState<any>(null);
  const [showParking, setShowParking] = useState<any>(null);
  const [showRouteDetails, setShowRouteDetails] = useState<any>(null);

  let mType = localStorage.getItem(LOCAL_STORAGE.MAP_TYPE);
  const [selectedMapType, setSelectedMapType] = useState<any>(
    mType ? Number(mType) : 0
  );
  let mapLocalStorage: any = {
    lat: 12.9539456,
    lng: 77.4661304,
    zoom: 10,
  };

  if (localStorage.getItem(LOCAL_STORAGE.MAP)) {
    mapLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE.MAP));
  }
  const [mapPosition, setMapPosition] = useState<any>(mapLocalStorage);

  useEffect(() => {
    if (loading) {
      getVehiclesOnMap();
    }
  }, [loading]);

  const getVehiclesOnMap = () => {
    const args = { type: filter };
    API_HANDLER_MASTER.getVehiclesOnMap(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const delay = response.records;
        setDelayedVehicles(delay);
        setVehicles(res.response.records);
      }
      setLoading(false);
      getAreas();
    });
  };

  const getAreas = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    API_HANDLER_GEOGRAPHY.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const areaRecords = response.records;
        for (let i = 0; i < areaRecords.length; i++) {
          if (areaRecords[i].vertices) {
            let vertices = JSON.parse(areaRecords[i].vertices).map((point) => {
              point[0] = Number(point[0]);
              point[1] = Number(point[1]);
              return point;
            });
            areaRecords[i].vertices = vertices;
          } else {
            areaRecords[i].vertices = [];
          }
        }
        setAreas(areaRecords);
        getTrips();
      }
    });
  };

  const getTrips = async () => {
    const args = { activeStatus: "true" };
    const res: any = await API_HANDLER_INDENT.getTrips(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.indentNo,
        };
      });
      setTrips(list);
      getDrivers();
    }
  };

  const getDrivers = async () => {
    const args = { activeStatus: "true" };
    const res: any = await API_HANDLER_MASTER.getDrivers(args);
    const { status, response } = res;
    if (status === 200) {
      const driver = response.records;
      let list = response.records.map((r: any) => {
        return {
          id: r.userId,
          label: r.userName,
        };
      });
      setDrivers(list);
      getVehicles(); // for dropdown
    }
  };

  const getVehicles = async () => {
    const args = { activeStatus: "true", shortMode: "true" };
    const res: any = await API_HANDLER_MASTER.getVehicles(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.vehicleNumber,
        };
      });
      setVehiclesList(list);
      getVehicleTrack();
    }
  };

  const getVehicleTrack = async () => {
    const args = { activeStatus: "true" };
    const res: any = await API_HANDLER_INDENT.getVehicleTrack(args);
    const { status, response } = res;
    if (status === 200) {
      // route points converting object containing object to 2d array
      const routePoints = res.response.records[0].route_points;
      const points = routePoints.map((point) => [
        point.latitude,
        point.longitude,
      ]);
      console.log("points", points);
      setShowRoutePoints(points);
      //Route Parking
      const routeParking = res.response.records[0].route_parkings;
      setShowParking(routeParking);

      //Route Details
      const routeDetails = res.response.records[0].route_details;
      setShowRouteDetails(routeDetails);
    }
  };

  const createClusterCustomIcon = (cluster) => {
    const count = cluster.getChildCount();
    let size = "LargeXL";
    if (count < 10) {
      size = "Small";
    } else if (count > 9 && count < 100) {
      size = "Medium";
    } else if (count > 99 && count < 1000) {
      size = "Large";
    } else if (count > 999 && count < 10000) {
      size = "XLarge";
    } else if (count > 9999 && count < 100000) {
      size = "XXLarge";
    } else if (count > 99999 && count < 1000000) {
      size = "XXXLarge";
    }
    const options = {
      cluster: `markerCluster${size}`,
    };
    return L.divIcon({
      html: `<div>
          <span class="markerClusterLabel">${count}</span>
        </div>`,
      className: `${options.cluster}`,
    });
  };

  const getTileUrl = (mapType = 0) => {
    localStorage.setItem(LOCAL_STORAGE.MAP_TYPE, mapType.toString());
    let url = CONFIG.OSM_TILE_URL;
    switch (mapType) {
      case 0:
        url = CONFIG.OSM_TILE_URL;
        break;
      case 1:
        url = CONFIG.GOOGLE_STREETS_MAP_URL;
        break;
      case 2:
        url = CONFIG.GOOGLE_SATELLITE_MAP_URL;
        break;
      case 3:
        url = CONFIG.GOOGLE_HYBRID_MAP_URL;
        break;
      default:
        url = CONFIG.OSM_TILE_URL;
        break;
    }
    return url;
  };

  const onDragMap = (e) => {
    const center = e.target.getCenter();
    const zoom = e.target.getZoom();
    let mapLocalStorage = {
      lat: center.lat,
      lng: center.lng,
      zoom,
    };
    localStorage.setItem(LOCAL_STORAGE.MAP, JSON.stringify(mapLocalStorage));
  };

  const onPrintMap = () => {
    let fileName =
      "Map_" + DateFunctions.getDate("now", "from", "DD_MM_YYYY_HH_mm_ss");
    console.log("printMap: ", fileName);
    // printControlRef.printMap("A4Landscape", fileName);
    console.log("printControlRef: ", printControlRef);
  };

  const updateLocation = (pos: any, zoom = DEFAULTS.MAX_ZOOM - 2) => {
    localStorage.setItem(LOCAL_STORAGE.MAP, JSON.stringify({ ...pos, zoom }));
    setMapPosition({ ...pos, zoom });
    setLocMarker({ ...pos, name: pos.lat + "," + pos.lng });
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 250);
  };

  const onEditPoly = (p) => {
    let latLngs = [];
    for (let i in p.layers._layers) {
      latLngs = p.layers._layers[i]._latlngs;
    }
  };

  const clearPolygonLayers = () => {
    let e = document.createEvent("Event");
    e.initEvent("click", true, true);
    let cb = document.querySelector(".leaflet-draw-edit-remove");
    if (cb) {
      cb.dispatchEvent(e);
    }

    let e2 = document.createEvent("Event");
    e2.initEvent("click", true, true);
    cb = document.querySelector(
      "ul.leaflet-draw-actions.leaflet-draw-actions-bottom li:last-child>a"
    );
    if (cb) {
      cb.dispatchEvent(e2);
    }
  };

  const onCreatePoly = (d) => {
    let vertices = d.layer._latlngs;
    if (vertices.length > 0) {
      vertices = vertices[0];
    }
    setSelectedPolygon(vertices);
    clearPolygonLayers();
    const fList = [];
    for (let i = 0; i < vehicles.length; i++) {
      const lat = vehicles[i].lat;
      const lng = vehicles[i].lng;
      if (COMMON_JS.isPointInPolygon(vertices, lat, lng)) {
        fList.push(vehicles[i]);
      }
    }
    setFilteredList(fList);
  };

  const onDeletePoly = (e) => {
    console.log("onDeletePoly: ", e);
  };

  const mPos = {
    lat: Number(mapPosition.lat),
    lng: Number(mapPosition.lng),
  };
  let zoom = Number(mapPosition.zoom);

  const onClickPolygon = (info: any) => {
    setPolygonInfo(info);
    const infoObj = info.vertices.map((latLngPair) => ({
      lat: latLngPair[0],
      lng: latLngPair[1],
    }));
    const filteredList = vehicles.filter((vehicle) => {
      return COMMON_JS.isPointInPolygon(infoObj, vehicle.lat, vehicle.lng);
    });
    setPolygonVehicles(filteredList);
  };

  const onTripDeliveries = (detail) => {
    polygonFitBounds(deliveriesRef.tripGroupRef, detail.vertices);
  };

  const polygonFitBounds = (polygonRef, boundData) => {
    let bounds = boundData.map((bound) => ({
      lat: bound[0],
      lng: bound[1],
    }));
    if (!bounds) {
      let layers = polygonRef.current.leafletElement._layers;
      for (let i in layers) {
        bounds = layers[i]._bounds;
      }
    }
    if (bounds) {
      mapRef.current.leafletElement.fitBounds(bounds);
    }
  };

  const printOptions = {
    position: "topleft",
    sizeModes: ["Current", "A4Portrait", "A4Landscape"],
    hideControlContainer: false,
    title: INFO.EXPORT_AS_PDF,
  };

  const downloadOptions = {
    position: "topleft",
    sizeModes: ["Current", "A4Portrait", "A4Landscape"],
    hideControlContainer: false,
    title: INFO.EXPORT_AS_PNG,
    exportOnly: true,
  };

  console.log("Areas", areas);

  return (
    <div className={"mapPage"}>
      <div className="mapPageContainer">
        {loading ? (
          <div>
            <SkeletonBox height={window.innerHeight * 1} width={"100%"} />
          </div>
        ) : (
          <div id="mapContainer" className={"mapContainer "}>
            <MapFilters
              clustering={clustering}
              showMarkers={showMarkers}
              showLabels={showLabels}
              showVehicles={showVehicles}
              showAreas={showAreas}
              vehicles={vehicles}
              showRadar={showRadar}
              showDelay={showDelay}
              radarData={radarData}
              radarMainVehicle={radarMainVehicle}
              futureVehicle={futureVehicle}
              showTrips={showTrips}
              selectedMapType={selectedMapType}
              locMarker={locMarker}
              setClustering={(val: any) => {
                setClustering(val);
              }}
              setFutureVehicle={(val: any) => {
                setFutureVehicle(val);
              }}
              setFutureViewVehicles={(val: any) => {
                setFutureViewVehicles(val);
              }}
              setShowMarkers={(val: any) => {
                setShowMarkers(val);
              }}
              setShowLabels={(val: any) => {
                setShowLabels(val);
              }}
              setShowAreas={(val: any) => {
                setShowAreas(val);
              }}
              setShowVehicles={(val: any) => {
                setShowVehicles(val);
              }}
              setShowTrips={(val: any) => {
                setShowTrips(val);
              }}
              setSelectedMapType={(val: any) => {
                setSelectedMapType(val);
              }}
              setTripDelivery={(val: any) => {
                setTripDelivery(val);
              }}
              setDetails={(val: any) => {
                setDetails(val);
              }}
              setRadarData={(val: any) => {
                setRadarData(val);
              }}
              setShowRadar={(val: any) => {
                setShowRadar(val);
              }}
              setRadarMainVehicle={(val: any) => {
                setRadarMainVehicle(val);
              }}
              setShowDelay={(val: any) => {
                setShowDelay(val);
              }}
              setVehicles={(val: any) => {
                setVehicles(val);
              }}
              updateLocation={updateLocation}
            />
            <PolyFilters
              onPrintMap={onPrintMap}
              resetFilteredList={() => {
                setFilteredList(null);
                setSelectedPolygon([]);
              }}
            />
            <Map
              whenCreated={(map) => {
                mapRef.current = map;
              }}
              center={mPos}
              zoom={zoom}
              maxZoom={DEFAULTS.MAX_ZOOM}
              minZoom={DEFAULTS.MIN_ZOOM}
              viewport={null}
              className="uiMap"
              ref={mapRef}
              onmoveend={onDragMap}
              onzoomend={onDragMap}
              style={{
                width: window.innerWidth * 0.96,
                height: window.innerHeight * 0.98,
              }}
            >
              <PrintControl {...printOptions} />
              <PrintControl {...downloadOptions} />

              <TileLayer url={getTileUrl(selectedMapType)} />

              {clustering ? (
                <MarkerClusterGroup
                  iconCreateFunction={createClusterCustomIcon}
                  showCoverageOnHover={true}
                >
                  <MapMarkers
                    tripDelivery={tripDelivery}
                    showMarkers={showMarkers}
                    showLabels={showLabels}
                    points={
                      futureViewVehicles
                        ? futureViewVehicles
                        : tripDelivery
                        ? tripDelivery
                        : radarData
                        ? radarData
                        : vehicles
                    }
                    markerType={MAP_MARKER_TYPES["VEHICLES"]}
                  />
                </MarkerClusterGroup>
              ) : (
                <MapMarkers
                  showMarkers={showMarkers}
                  showLabels={showLabels}
                  points={
                    futureViewVehicles
                      ? futureViewVehicles
                      : tripDelivery
                      ? tripDelivery
                      : radarData
                      ? radarData
                      : vehicles
                  }
                  markerType={MAP_MARKER_TYPES["VEHICLES"]}
                />
              )}

              {locMarker.lat && (
                <MapMarkers
                  showMarkers={showMarkers}
                  showLabels={showLabels}
                  points={[locMarker]}
                  markerType={MAP_MARKER_TYPES["NORMAL"]}
                />
              )}

              {/* POI Edit Controls */}
              <FeatureGroup ref={mapDrawControlGroupRef}>
                <EditControl
                  position="topright"
                  onEdited={onEditPoly}
                  onCreated={onCreatePoly}
                  onDeleted={onDeletePoly}
                  draw={{}}
                  ref={mapDrawControlRef}
                />
                {selectedPolygon.length > 0 && (
                  <Polygon positions={selectedPolygon} />
                )}
              </FeatureGroup>

              {/* API NOT DONE getVehicleTrack */}
              {/* {showTrips && (
                <Polyline positions={showRoutePoints} color={"red"} />
              )}
              {showTrips && (
                <MapMarkers
                  showParking={showParking}
                  showMarkers={showMarkers}
                  showLabels={showLabels}
                  points={showParking}
                  markerType={MAP_MARKER_TYPES["REGULAR_DELAY"]}
                />
              )} */}
              <MapPlotting
                details={details}
                childRef={deliveriesRef}
                tripDelivery={tripDelivery}
                showAreas={showAreas}
                areas={areas}
                showMarkers={showMarkers}
                showLabels={showLabels}
                showDelay={showDelay}
                onClickPolygon={onClickPolygon}
                radarMainVehicle={radarMainVehicle}
                nearVehicles={nearVehicles}
                delayedVehicles={delayedVehicles}
              />
            </Map>

            {/* Map Filters */}
            <SpeedDial
              ariaLabel="Filters"
              className="uiSpeedDial"
              sx={{ position: "absolute", bottom: 16, right: 16 }}
              icon={<FilterIcon />}
              open={true}
            >
              {actions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  className={"iconBtn"}
                  onClick={() => {
                    setFilter(action.id);
                    setLoading(true);
                  }}
                />
              ))}
            </SpeedDial>
          </div>
        )}
      </div>
      <AreaVehiclesInfo
        polygonVehicles={polygonVehicles}
        polygonInfo={polygonInfo}
        setPolygonInfo={setPolygonInfo}
      />
      <FutureView
        showVehicles={showVehicles}
        setShowVehicles={(val: any) => {
          setShowVehicles(val);
        }}
        setFutureVehicle={(val: any) => {
          setFutureVehicle(val);
        }}
        setFutureViewVehicles={(val: any) => {
          setFutureViewVehicles(val);
        }}
      />
      <Radar
        showRadar={showRadar}
        vehiclesList={vehiclesList}
        vehiclesRef={vehiclesRef}
        radarLoading={radarLoading}
        setShowRadar={(val: any) => {
          setShowRadar(val);
        }}
        setNearVehicles={(val: any) => {
          setNearVehicles(val);
        }}
        setClustering={(val: any) => {
          setClustering(val);
        }}
        setShowAreas={(val: any) => {
          setShowAreas(val);
        }}
        setRadarLoading={(val: any) => {
          setRadarLoading(val);
        }}
        setRadarData={(val: any) => {
          setRadarData(val);
        }}
        setRadarMainVehicle={(val: any) => {
          setRadarMainVehicle(val);
        }}
      />
      <TripDeliveries
        showTrips={showTrips}
        tripDelivery={tripDelivery}
        trips={trips}
        tripsRef={tripsRef}
        vehiclesRef={vehiclesRef}
        vehiclesList={vehiclesList}
        drivers={drivers}
        driverRef={driverRef}
        setShowMarkers={(val: any) => {
          setShowMarkers(val);
        }}
        setShowAreas={(val: any) => {
          setShowAreas(val);
        }}
        setTripDelivery={(val: any) => {
          setTripDelivery(val);
        }}
        setDetails={(val: any) => {
          setDetails(val);
        }}
        setShowTrips={(val: any) => {
          setShowTrips(val);
        }}
        onLocationUpdate={onTripDeliveries}
      />
    </div>
    // If human is clicked, then send type="users". If it is clicked again/disable, then dont send type
  );
};

export default MapPage;
